import { IGetDashboardEntregaObrasInformationUseCase } from "../../../presentation/useCases/read/get_dashboard_entrega_obras_information_use_case";
import { DashboardEntregaObras } from "../../models/dashboard_entrega_obras";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetDashboardEntregaObrasInformationUseCase
 */

export class GetDashboardEntregaObrasInformationUseCase implements IGetDashboardEntregaObrasInformationUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getDashboardEntregaObrasInformation(
  ): Promise<DashboardEntregaObras> {
    return await this.repository.getDashboardEntregaObrasInformation();
  }
}
